(function () {
  'use strict';
  if (window.DubiaPromotionDrawers) return;

  var KEY = 'dubia-promotion-session-v2';
  var state;
  var available = true;
  var pageActive = true;
  try {
    state = JSON.parse(window.sessionStorage.getItem(KEY) || 'null');
    if (!state || !Number.isInteger(state.steps) || state.steps < 0 || !Array.isArray(state.products) || !state.shown) {
      state = { steps: 0, products: [], shown: {}, last: null };
      // Respect a promotion already shown before this deployment in the same tab.
      var legacy = window.sessionStorage.getItem('dubia-promotion-shown-this-session');
      if (legacy === 'app' || legacy === 'account') {
        state.shown[legacy] = true;
        state.last = { kind: legacy, step: 0, closedAt: Date.now() };
      }
    }
  } catch (_) { available = false; }

  function save() {
    if (!available) return false;
    try {
      var value = JSON.stringify(state);
      window.sessionStorage.setItem(KEY, value);
      available = window.sessionStorage.getItem(KEY) === value;
    } catch (_) { available = false; }
    return available;
  }

  function recordStep() {
    if (!available || !pageActive) return;
    state.steps += 1;
    save();
  }

  window.DubiaPromotionDrawers = {
    hasShown: function (kind) { return !available || Boolean(state.shown[kind]); },
    canShow: function (kind, minimum, ignoreBrowsing) {
      if (!available || !pageActive || state.shown[kind]) return false;
      if (!ignoreBrowsing && state.steps < minimum) return false;
      var last = state.last;
      return !last || (last.closedAt !== null && state.steps - last.step >= 2);
    },
    shown: function (kind) {
      if (!available) return false;
      state.shown[kind] = true;
      state.last = { kind: kind, step: state.steps, closedAt: null };
      return save();
    },
    closed: function (kind) {
      if (!available || !state.last || state.last.kind !== kind || state.last.closedAt !== null) return;
      state.last.closedAt = Date.now();
      state.last.step = state.steps;
      save();
    },
    track: function (kind, action) {
      // No customer identifiers. Tag-manager configuration determines forwarding.
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: 'promotion_drawer_' + action, drawer: kind, campaign: 'frequency-v2' });
      } catch (_) { /* Analytics must never block a dismissal or navigation. */ }
    }
  };

  recordStep();
  window.addEventListener('dubia:product-drawer-viewed', function (event) {
    if (!available || !pageActive) return;
    var handle = event.detail && event.detail.handle;
    if (typeof handle !== 'string' || !handle || state.products.indexOf(handle) !== -1) return;
    state.products.push(handle);
    recordStep();
  });
  window.addEventListener('pagehide', function () { pageActive = false; });
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) {
      // A cached page must not overwrite impressions recorded on newer pages.
      try { state = JSON.parse(window.sessionStorage.getItem(KEY)); } catch (_) { available = false; }
      if (!state) available = false;
      pageActive = true;
      recordStep();
    }
  });
})();
